import { Box, Button, Divider, Grid, Step, StepLabel, Stepper, TextField, Typography } from '@mui/material'
import moment from 'moment';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import api from '../../../../components/services/api'

export default function BookingInformation() {
    const { id } = useParams()
    const [data, setData] = useState(null)
    const history = useHistory();

    const getData = async () => {
        const res = await api.get(`api/cargotracking/detail/${id}`)
        const data = await res.data
        setData(data)
    }
    useEffect(() => {
        getData()
    }, [])
    const isOneWayImport = data?.TripType === 'One-Way' && data?.TripDirection === 'Import';
    const isOneWayExport = data?.TripType === 'One-Way' && data?.TripDirection === 'Export';
    // ป้ายชนิดตู้ตาม gender จริง (ไม่ hardcode ว่า inbound=empty เสมอ)
    const inboundGenderLabel = (data?.InboundContainerGender || 'Empty') + ' Container';
    const outboundGenderLabel = (data?.OutboundContainerGender || 'Laden') + ' Container';
    // timeline ปรับตาม trip type: One-Way Import จบที่ In Stock (ไม่มีขาออก), Export เริ่มที่ pickup (ไม่มีขาเข้า)
    const roundTripSteps = [
        { label: 'Gate Out', sub: data?.InboundGateOut },
        { label: 'Gate IN', sub: data?.OutboundGateOut },
        { label: 'Discharge', sub: 'CY' },
        { label: 'Pick-up', sub: 'Factory' },
        { label: 'Return', sub: 'CY' },
        { label: 'Loading', sub: '' },
        { label: 'Gate Out', sub: data?.OutboundGateOut },
        { label: 'Gate IN', sub: data?.InboundGateOut },
    ];
    const importSteps = [
        { label: 'Gate Out', sub: data?.InboundGateOut },
        { label: 'Gate IN', sub: data?.InboundGateOut },
        { label: 'Discharge', sub: 'CY' },
        { label: 'Pick-up', sub: 'Factory' },
        { label: 'In Stock', sub: 'CY' },
    ];
    const exportSteps = [
        { label: 'Pick-up', sub: 'Factory' },
        { label: 'Return', sub: 'CY' },
        { label: 'Loading', sub: '' },
        { label: 'Gate Out', sub: data?.OutboundGateOut },
        { label: 'Gate IN', sub: data?.OutboundGateOut },
    ];
    const steps = isOneWayImport ? importSteps : isOneWayExport ? exportSteps : roundTripSteps;
    const activeStep = isOneWayImport ? (
        data?.LatestStatus === 'Inbound Gate Out' ? 1 :
            data?.LatestStatus === 'Inbound Gate In' ? 2 :
                data?.LatestStatus === 'Discharge In' ? 3 :
                    data?.LatestStatus === 'Pick-up' ? 4 :
                        (data?.LatestStatus === 'Return' || data?.LatestStatus === 'In Stock' || data?.LatestStatus === 'Completed') ? 5 : 0
    ) : isOneWayExport ? (
        data?.LatestStatus === 'Pick-up' ? 1 :
            data?.LatestStatus === 'Return' ? 2 :
                data?.LatestStatus === 'Loading Out' ? 3 :
                    data?.LatestStatus === 'Outbound Gate Out' ? 4 :
                        data?.LatestStatus === 'Outbound Gate In' ? 5 : 0
    ) : (
        data?.LatestStatus === 'Inbound Gate Out' ? 1 :
            data?.LatestStatus === 'Inbound Gate In' ? 2 :
                data?.LatestStatus === 'Discharge In' ? 3 :
                    data?.LatestStatus === 'Pick-up' ? 4 :
                        data?.LatestStatus === 'Return' ? 5 :
                            data?.LatestStatus === 'Loading Out' ? 6 :
                                data?.LatestStatus === 'Outbound Gate Out' ? 7 : 8
    );
    return (
        <div>
            <Box sx={{ display: "flex", marginTop: "30px" }}>
                <Grid
                    container
                    spacing={2}
                    sx={{ display: "flex", alignItems: "center" }}
                >
                    <Grid item xs={4}>
                        <TextField label="Customer Name" size='small' value={data?.CustomerName || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={8}></Grid>
                    <Grid item xs={4}>
                        <TextField label="Sale Order Number" size='small' value={data?.SaleOrderNo || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={8}></Grid>
                    <Grid item xs={4}>
                        <TextField label="Booking No" size='small' value={data?.BookingNo || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={8}></Grid>
                    <Grid item xs={4}>
                        <TextField label="Shipper Ref No" size='small' value={data?.ShipperRefNo || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={8}></Grid>

                    <Grid item xs={4}>
                        <TextField label="Size" size='small' value={data?.Size || ''} sx={{ width: "100%" }} />
                    </Grid>

                    <Grid item xs={4}>
                        <TextField label="Quantity" size='small' value={data?.Quantity || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={12}>
                        <Typography
                            sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
                        >
                            Booking Information
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Shipping Line" size='small' value={data?.ShippingLine || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={8}></Grid>
                    <Grid item xs={4}>
                        <TextField label="Port of Loading" size='small' value={data?.POLLocationName || ''} sx={{ width: "100%" }} />
                    </Grid>

                    <Grid item xs={4}>
                        <TextField label="ETD" size='small' value={data?.ETDPOLDate + ' ' + data?.ETDPOLTime || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={4}>
                        <TextField label="Port of Discharge" size='small' value={data?.PODLocationName || ''} sx={{ width: "100%" }} />
                    </Grid>

                    <Grid item xs={4}>
                        <TextField label="ETA" size='small' value={data?.ETAPODDate + ' ' + data?.ETAPODTime || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={4}>
                        <TextField label="Intended Vessel" size='small' value={data?.IntendedVessel || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={8}></Grid>
                </Grid>

            </Box>
            <Box sx={{ width: '100%', marginTop: '50px' }}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((s, i) => (
                        <Step key={i}>
                            <StepLabel>{s.label}<br /> {s.sub}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <Box sx={{ display: "flex", marginTop: "50px" }}>
                <Grid
                    container
                    spacing={2}
                    sx={{ display: "flex", alignItems: "center" }}
                >
                    <Grid item xs={12}>
                        <Typography
                            sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
                        >
                            Schedule Detail
                        </Typography>
                    </Grid>
                    {/* ซ่อนขาเข้าเมื่อเป็น One-Way/Export (เริ่มที่โรงงาน ไม่มีขาเข้า) */}
                    {!isOneWayExport && (<>
                    <Grid item xs={2}>
                        <Typography
                            sx={{ fontWeight: "500", fontSize: "16px", color: "#30318d", textAlign: 'end' }}
                        >
                            {inboundGenderLabel}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Gate OUT" size='small' value={data?.InboundGateOut || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Gate IN" size='small' value={data?.OutboundGateOut || ''} sx={{ width: "100%" }} />
                    </Grid>

                    <Grid item xs={2}>

                    </Grid> 
                    <Grid item xs={2}>

                    </Grid>

                    <Grid item xs={3}>
                        <TextField label="ETD Gate Out" size='small' value={data?.InboundETDGateOut ? moment(data?.InboundETDGateOut).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField label="ETA Gate IN" size='small' value={data?.InboundETDGateOut ? moment(data?.InboundETDGateOut).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField label="VOY IN" size='small' value={data?.InboundVoyNo || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>

                    {data?.InboundTransportGroupId === 'G002' && <>
                        <Grid item xs={2}>

                        </Grid>

                        <Grid item xs={3}>
                            <TextField label="ETD Gate Out" size='small' value={data?.InboundETDGateOut_2 ? moment(data?.InboundETDGateOut_2).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField label="ETA Gate IN" size='small' value={data?.InboundETDGateOut_2 ? moment(data?.InboundETDGateOut_2).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField label="VOY IN" size='small' value={data?.InboundVoyNo_2 || ''} sx={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={2}>
                        </Grid>
                        <Grid item xs={2}>

                        </Grid>

                        <Grid item xs={3}>
                            <TextField label="ETD Gate Out" size='small' value={data?.InboundETDGateOut_3 ? moment(data?.InboundETDGateOut_3).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField label="ETA Gate IN" size='small' value={data?.InboundETDGateOut_3 ? moment(data?.InboundETDGateOut_3).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField label="VOY IN" size='small' value={data?.InboundVoyNo_3 || ''} sx={{ width: "100%" }} />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid></>}
                    <Grid item xs={2}>

                    </Grid>
                    <Grid item xs={2}>

                    </Grid>
                    {/* <Grid item xs={4}>
                        <TextField label="Vessel" size='small' value={''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Voyage" size='small' value={''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>

                    </Grid> */}
                    </>)}
                    {/* ซ่อนขาออกเมื่อเป็น One-Way/Import (จบที่โรงงาน/เข้า stock ไม่มีขาออก) */}
                    {!isOneWayImport && (<>
                    <Divider sx={{ width: '100%', margin: '30px 0px' }} />

                    <Grid item xs={2}>
                        <Typography
                            sx={{ fontWeight: "500", fontSize: "16px", color: "#30318d", textAlign: 'end' }}
                        >
                            {outboundGenderLabel}
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Gate OUT" size='small' value={data?.OutboundGateOut || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Gate IN" size='small' value={data?.InboundGateOut || ''} sx={{ width: "100%" }} />
                    </Grid>

                    <Grid item xs={2}>

                    </Grid>
                    <Grid item xs={2}>

                    </Grid>
                    <Grid item xs={3}>
                        <TextField label="ETD Gate Out" size='small' value={data?.OutboundETDGateOut ? moment(data?.OutboundETDGateOut).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField label="ETA Gate IN" size='small' value={data?.OutboundETAGateIn ? moment(data?.OutboundETAGateIn).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField label="VOY OUT" size='small' value={data?.OutboundVoyNo || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>
                    {data?.OutboundTransportGroupId === 'G002' && <>
                    <Grid item xs={2}>

                    </Grid>
                    <Grid item xs={3}>
                        <TextField label="ETD Gate Out" size='small' value={data?.OutboundETDGateOut_2 ? moment(data?.OutboundETDGateOut_2).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField label="ETA Gate IN" size='small' value={data?.OutboundETAGateIn_2 ? moment(data?.OutboundETAGateIn_2).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField label="VOY OUT" size='small' value={data?.OutboundVoyNo_2 || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>
                    <Grid item xs={2}>

                    </Grid>
                    <Grid item xs={3}>
                        <TextField label="ETD Gate Out" size='small' value={data?.OutboundETDGateOut_3 ? moment(data?.OutboundETDGateOut_3).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField label="ETA Gate IN" size='small' value={data?.OutboundETAGateIn_3 ? moment(data?.OutboundETAGateIn_3).format('DD-MM-yyyy hh:mm') : '' || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField label="VOY OUT" size='small' value={data?.OutboundVoyNo_3 || ''} sx={{ width: "100%" }} />
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>
                    </>}
                    <Grid item xs={2}>

                    </Grid>
                    <Grid item xs={2}>

                    </Grid>
                    </>)}


                </Grid>
            </Box>
            <Box sx={{ display: "flex", marginTop: "25px" }}>
                <Button
                    sx={{ width: 80 }}
                    type="button"
                    variant="outlined"
                    style={{
                        color: "#80c340",
                        borderColor: "#80c340",
                        marginRight: "10px",
                    }}
                    onClick={history.goBack}
                >
                    close
                </Button>
            </Box>
        </div>
    )
}
